import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMe } from './adminApi';
import './AdminButton.css';

/**
 * Header button that routes to the admin area.
 * Renders nothing unless the current user is an active admin.
 */
const AdminButton = ({ translate }) => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const t = translate || ((x) => x);

  useEffect(() => {
    let mounted = true;
    getMe()
      .then((d) => {
        if (mounted) setIsAdmin(Boolean(d && d.is_admin && d.is_active));
      })
      .catch(() => {
        if (mounted) setIsAdmin(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!isAdmin) return null;

  return (
    <button
      className="admin-nav-btn"
      onClick={() => navigate('/admin')}
      title={t('Admin & Analytics')}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 3v18h18" />
        <rect x="7" y="11" width="3" height="6" />
        <rect x="12" y="7" width="3" height="10" />
        <rect x="17" y="13" width="3" height="4" />
      </svg>
      <span>{t('Dashboard')}</span>
    </button>
  );
};

export default AdminButton;
